import { render, staticRenderFns } from "./TestApplicationForm.vue?vue&type=template&id=5aa8db0a&scoped=true&"
import script from "./TestApplicationForm.vue?vue&type=script&lang=js&"
export * from "./TestApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./TestApplicationForm.vue?vue&type=style&index=0&id=5aa8db0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8db0a",
  null
  
)

export default component.exports